import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import Constants from "../frontLayout/Variables/Constants";
import logo from "../assets/images/logo.png";

const LoginComponent = ({ setIsOpen, setShowLogin, actionPerform }) => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const location = useLocation();
    const navigate = useNavigate();
    const [btnIsDisabled, setBtnIsDisabled] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateEmail = () => {
        const email = formData.email;
        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (!email) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Email address is required");
            return false;
        }
        if (!emailPattern.test(email)) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Invalid email address");
            return false;
        }
        return true;
    };

    const validatePassword = () => {
        const phone = formData.password;

        if (!phone) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Phone number is required");
            return false;
        }

        return true;
    };



    const handleAddToCart = (arr) => {
        try {

            axios
                .post(
                    Constants.postUrls.AddToCart,
                    arr,
                    {
                        headers: {
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                )
                .then((resp) => {
                    if (resp.data.status === "success") {
                        localStorage.removeItem("cart");
                        setIsOpen(false);
                        // window.location.reload();
                    }
                })
                .catch((error) => {
                    console.error("Error while adding product to cart:", error);
                    setIsOpen(false);
                    // window.location.reload();
                });
        } catch (error) {
            try {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
                const { status, message } = error.response.data
                if (status === 401 && message === "Unauthorized!") {
                    localStorage.removeItem("token");
                    window.location.href = "/";
                }
            } catch (error) {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
            }
        }
    };

    const fetchMultipleProducts = async ({ localCartData }) => {
        try {
            const productIds = localCartData.map(io => io._id)
            const resp = await axios.post(
                Constants.postUrls.getMultipleProduct,
                { product_ids: productIds },
            );
            if (resp.data.status === "success") {
                const cartData = resp.data.data
                if (cartData && Array.isArray(cartData)) {
                    cartData.map(cart => {
                        productIds.map(io => {
                            if (io._id === cart._id) {
                                cart.quantity = io.quantity
                            }
                        })
                    })

                    const arr = [];

                    cartData.map(cart => {
                        localCartData.map(io => {
                            if (io._id === cart._id) {
                                arr.push({
                                    product_id: cart._id,
                                    quantity: io.quantity
                                })
                            }
                        })
                    })

                    handleAddToCart(arr)
                }
            }
        } catch (error) {
            try {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
                const { status, message } = error.response.data
                if (status === 401 && message === "Unauthorized!") {
                    localStorage.removeItem("token");
                    window.location.href = "/";
                }
            } catch (error) {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBtnIsDisabled(true);
        if (validateEmail() && validatePassword()) {
            const payload = {
                email: formData.email,
                password: formData.password,
            };

            try {
                const res = await axios.post(Constants.postUrls.login, payload);
                if (res.data.status === "success") {
                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.success(res.data.message, {
                        style: { backgroundColor: "green", color: "white" },
                    });
                    localStorage.setItem("token", res.data.token);
                    await actionPerform();
                    const cartData = localStorage.getItem("cart")
                    if (cartData) {
                        const localCartData = JSON.parse(cartData);
                        if (localCartData && Array.isArray(localCartData)) {
                            fetchMultipleProducts({ localCartData })
                        } else {
                            setIsOpen(false);
                            // window.location.reload();
                        }
                    } else {
                        setIsOpen(false);
                        // window.location.reload();
                    }
                } else {
                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.error(res.data.message);
                }
            } catch (err) {
                if (err.response) {
                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.error(err.response.data.message);
                }
                console.error(err);
            }
        }
        setBtnIsDisabled(false);
    };
    return (<>
        <div className="d-flex align-items-center my-4">
            <h1 className="fs-36 fw-400 m-0">Please Sign in first! 👋</h1>
        </div>
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label className="fs-16 fw-400">Email</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={formData.email}
                    onBlur={validateEmail}
                    placeholder="Example@email.com"
                />
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
                <Form.Label className="fs-16 fw-400">Phone</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="tel"
                    name="password"
                    onChange={handleChange}
                    value={formData.password}
                    onBlur={validatePassword}
                    placeholder="Enter phone number"
                    maxLength={10}
                />
            </Form.Group>
            {/* <Form.Group className="text-end mb-4">
                        <NavLink to={"/forgot-password"} className="FP_link fs-14 fw-400">Forgot Password?</NavLink>
                    </Form.Group> */}

            <div className="d-grid mb-4">
                <Button variant="warning" disabled={btnIsDisabled} type="submit">
                    Sign In
                </Button>
            </div>
            <div className="text-center mt-4">
                <p className="fs-16 fw-400">
                    Don't you have an account?{" "}
                    <span className="text_brand_sepia_color" style={{ cursor: "pointer" }} onClick={() => setShowLogin(false)}>
                        Sign up
                    </span>
                </p>
            </div>
        </Form>
    </>)
}

export default LoginComponent